import * as React from "react"
import { Dialog, AppBar, Toolbar, IconButton, Slide, Box } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { TransitionProps } from "@mui/material/transitions"
import DetailCraftman from "../DetailCraftman/DetailCraftman"

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})

type Props = {
  open: boolean
  onClose: () => void
  craftmanId: number
}

const ModalDetailCraftman: React.FC<Props> = ({
  open,
  onClose,
  craftmanId,
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      scroll="paper"
    >
      <AppBar sx={{ position: "relative", bgcolor: "primary.main" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 3, background: "black", height: "100vh" }}>
        <DetailCraftman craftmanId={craftmanId} />
      </Box>
    </Dialog>
  )
}

export default ModalDetailCraftman
